import {useMutation} from 'react-query';
import {client} from './ApiClient';
import {mapSignupStateToLESignupCommand} from "../Helpers/Maps";
import {ILESignupCommand, ISignupState} from "../Helpers/Types";

type SignupCustomerParams = {
	urls: any
	domain: string
	deviceCode: string
	signupState: ISignupState
	session: string
	registeredCardNumber?: string
	noEmail?: boolean
	noTextMessages?: boolean
}

const signupCustomer = ({urls, domain, deviceCode, signupState, session, registeredCardNumber, noEmail, noTextMessages}: SignupCustomerParams) => {
	const body: ILESignupCommand & {TrackingKey?: string} = {
		...mapSignupStateToLESignupCommand(signupState),
		TrackingKey: registeredCardNumber,
	}
	if (noEmail !== undefined) {
		body.NoEmail = noEmail
	}
	if (noTextMessages !== undefined) {
		body.NoTextMessages = noTextMessages
	}
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/snippets/customer${session ? `/${session}` : ''}/commands/signups`, {
		body,
	});
}

export default function useSignupCustomer() {
	// @ts-ignore
	return useMutation(signupCustomer)
}